import styled from "styled-components";

export const OneMauveContainer = styled.div`
    font-family: 'Inter', sans-serif;
    position: fixed;
    top:0;
    left:0;
    width:100vw;
    height:100vh;
`;